import React from "react";
import styled from "styled-components";
import { HorizontalLine } from "../../containers/styledComponents";
import {
  CompassGreenButton,
  CompassWhiteButton,
} from "../../buttons/styledComponents";

const FooterContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: auto;
`;

const ButtonRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  margin-top: 20px;
`;

const ButtonContent = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export interface ModalFooterProps {
  /** Handler for close/cancel button */
  onClose?: () => void;
  /** Handler for primary action (submit/update) */
  onSubmit?: () => void;
  /** Text for close button (default: "Close") */
  closeText?: string;
  /** Text for submit button (default: "Submit") */
  submitText?: string;
  /** Hide the submit button */
  hideSubmit?: boolean;
  /** Hide the close/cancel button */
  hideClose?: boolean;
  /** Show a horizontal divider above buttons */
  showDivider?: boolean;
  /** Disable submit button */
  submitDisabled?: boolean;
  /** Show loading spinner on submit button */
  isLoading?: boolean;
  /** Custom content to render instead of default buttons */
  children?: React.ReactNode;
}

export const ModalFooter: React.FC<ModalFooterProps> = ({
  onClose,
  onSubmit,
  closeText = "Close",
  submitText = "Submit",
  hideSubmit = false,
  hideClose = false,
  showDivider = true,
  submitDisabled = false,
  isLoading = false,
  children,
}) => {
  if (children) {
    return (
      <FooterContainer>
        {showDivider && <HorizontalLine marginTop={20} marginBottom={0} />}
        <ButtonRow>{children}</ButtonRow>
      </FooterContainer>
    );
  }

  return (
    <FooterContainer>
      {showDivider && <HorizontalLine marginTop={20} marginBottom={0} />}
      <ButtonRow>
        {!hideClose && onClose && (
          <CompassWhiteButton onClick={onClose} disabled={isLoading}>
            {closeText}
          </CompassWhiteButton>
        )}
        {!hideSubmit && onSubmit && (
          <CompassGreenButton
            onClick={onSubmit}
            disabled={submitDisabled || isLoading}
          >
            <ButtonContent>{submitText}</ButtonContent>
          </CompassGreenButton>
        )}
      </ButtonRow>
    </FooterContainer>
  );
};
